import { Path } from '@/main/router/routerPath';
import Edit from './Edit.vue';
import List from './List.vue';
import { CRUMB_LABEL_EDIT, NAME } from './constants';

export const router = new Path(NAME, { List, Edit, SelectList: List }, CRUMB_LABEL_EDIT);
